import { TabContext, TabList, TabPanel } from "@mui/lab"
import { Accordion, AccordionDetails, AccordionSummary, Box, Grid, Tab, Typography } from "@mui/material"
import { useEffect, useState } from "react";
import { ASL_3, ASL_5 } from "../../global/multiAsl";
import { faqASL3 } from "../../global/faqASL3";
import { faqASL5 } from "../../global/faqASL5";
import ArrowCircleDownSharpIcon from '@mui/icons-material/ArrowCircleDownSharp';

export const FaqMultiAsl = () => {

    const [value, setValue] = useState(ASL_3.codice);

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    useEffect(() => {
        window.scroll(0, 0)
    }, [])

    const FaqAccordion = ({ index, titolo, descrizione }) => {
        return (

            <Accordion elevation={6} key={index} >
                <AccordionSummary
                    expandIcon={
                        <ArrowCircleDownSharpIcon style={{ color: '#005397', display: 'flex', fontSize: '35px' }} />
                    }
                >
                    <Typography sx={{ fontSize: { xs: '16px', md: '30px' }, fontWeight: 600, color: "#005397" }}> {titolo}</Typography>
                </AccordionSummary>
                <AccordionDetails key={index}>
                    <Typography sx={{ fontSize: { xs: '14px', md: '30px' }, color: "#005397" }}>
                        {descrizione}
                    </Typography>
                </AccordionDetails>
            </Accordion>
        )
    }
    return (
        <>
            <Box sx={{
                flexGrow: 1,
                overflow: 'hidden',
                with: "100%"
            }}>
                <Box sx={{ x: 'auto' }}>
                    <Grid container wrap="nowrap" >
                        <Grid item xs zeroMinWidth>

                            <Box sx={{ width: "100%", height: "150px", display: "flex" }}>
                                <Typography
                                    component='h1'
                                    sx={{
                                        color: "#005397",
                                        margin: "auto",
                                        textAlign: "center",
                                        fontSize: { xs: "25px", md: "40px" },
                                        fontWeight: 700,
                                    }}
                                >
                                    FAQ
                                </Typography>
                            </Box>
                        </Grid>
                    </Grid>
                </Box>

                <Box sx={{ my: 0, mx: 'auto', paddingBottom: "20vh" }}>
                    <Grid container wrap="nowrap" spacing={2}>
                        <Grid item> </Grid>
                        <Grid item xs zeroMinWidth>
                            <Box
                                sx={{
                                    width: "80%",
                                    margin: "auto",
                                    display: "flex",
                                    flexDirection: "column",
                                }}
                            >
                                <Box sx={{ width: '100%', display: "flex", justifyContent: 'center' }}>
                                    <TabContext value={value} >
                                        <Box sx={{ display: "flex", justifyContent: 'center', flexDirection: 'column' }}>
                                            <Box sx={{ display: "flex", justifyContent: 'center', }}>
                                                <TabList onChange={handleChange} aria-label="Tabs enti">
                                                    <Tab label="Asl 3" value={ASL_3.codice} disableRipple sx={{ fontSize: { xs: '16px', md: '30px' }, fontWeight: 600, color: "#005397" }} />
                                                    <Tab label="Asl 5" value={ASL_5.codice} disableRipple sx={{ fontSize: { xs: '16px', md: '30px' }, fontWeight: 600, color: "#005397" }} />
                                                </TabList>
                                            </Box>
                                            <Box>
                                                <TabPanel value={ASL_3.codice}>
                                                    {faqASL3?.map((faq, index) => {
                                                        return (
                                                            <FaqAccordion index={index} titolo={faq.titolo} descrizione={faq.descrizione} />
                                                        )
                                                    })
                                                    }
                                                </TabPanel>
                                                <TabPanel value={ASL_5.codice}>
                                                    {faqASL5?.map((faq, index) => {
                                                        return (
                                                            <FaqAccordion index={index} titolo={faq.titolo} descrizione={faq.descrizione} />
                                                        )
                                                    })
                                                    }
                                                </TabPanel>
                                            </Box>
                                        </Box>
                                    </TabContext>
                                </Box>
                            </Box>
                        </Grid>
                    </Grid>
                </Box>
            </Box>
        </>
    )
}